var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgEye = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 4C4.57552 4 2.44462 8.03889 2 9C2.44462 9.98889 4.53757 14 9 14C13.4245 14 15.5554 9.96111 16 9C15.5554 8.01111 13.4624 4 9 4ZM9 11.7778C7.50349 11.7778 6.28892 10.5333 6.28892 9C6.28892 7.46667 7.50349 6.22222 9 6.22222C10.4965 6.22222 11.7111 7.46667 11.7111 9C11.7111 10.5333 10.4965 11.7778 9 11.7778Z",
    fill: "currentColor"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgEye);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/eye.a3ffdd8906ae518bbd8c9722b57865bf.svg";